import * as Sentry from '@sentry/browser'
import { API_URL, NetWorkService, validResponse } from '@utils/API'
import { CODE_SUCCESS } from '@utils/constan'
import { detectEnvUat } from '@utils/general'
import { institutionNameOnOneLine } from '@utils/institutionName'
import { message } from 'antd'
import { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { matchPath, useLocation, useNavigate } from 'react-router-dom'
import { RootState } from 'store'
import { setEduBillDetail, setIsHome, Type_Initstate } from 'store/appSlice'
import HeaderBanner from './HeaderBanner'

interface P {
  isFull?: boolean
}

interface BannerDetail {
  bannerPath?: unknown
  orgName?: string
  logo?: string
  success?: boolean
  message?: string
}

interface BannerData {
  sourceKey: string
  images: string[]
  organization?: BannerDetail
}

const emptyImages: string[] = []

const Header: FC<P> = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const appState = useSelector<RootState, Type_Initstate>((state) => state.app)
  const { edubillDetail, listEdubillDetail } = appState
  const { pathname } = useLocation()
  const path = pathname.replace(/^\/uat(?=\/|$)/, '') || '/'
  const searchRoute = matchPath('/search/:orgCode/school/:schoolCode', path)
  const schoolRoute =
    searchRoute ||
    matchPath('/organization/:orgCode/school/:schoolCode/*', path) ||
    matchPath('/confirm-payment/organization/:orgCode/school/:schoolCode/*', path)
  const organizationRoute = matchPath('/search/:orgCode', path)
  const orgCode = schoolRoute?.params.orgCode || organizationRoute?.params.orgCode || edubillDetail?.orgCode
  const schoolCode = schoolRoute?.params.schoolCode || (organizationRoute ? undefined : edubillDetail?.schoolCode)
  const showBanner = !appState.isHome && path !== '/' && path !== '/payment-result'
  const sourceKey = orgCode ? `${orgCode}/${schoolCode || ''}` : undefined
  const showOrgName =
    !appState.isHome &&
    !!schoolCode &&
    !!edubillDetail?.orgName &&
    listEdubillDetail.filter((item) => item.orgCode === edubillDetail.orgCode).length > 1
  const [bannerData, setBannerData] = useState<BannerData>()
  const currentBannerData = bannerData?.sourceKey === sourceKey ? bannerData : undefined
  const dataGroup = currentBannerData?.organization
  const { Get } = NetWorkService
  useEffect(() => {
    if (!showBanner || !sourceKey) {
      setBannerData(undefined)
      return
    }

    let active = true
    const controller = new AbortController()
    setBannerData(undefined)
    const getBanner = async () => {
      try {
        const res = await Get<{ data?: BannerDetail }>({
          url: schoolCode
            ? `/api/organization/${orgCode}/school/${schoolCode}/edubill/detail`
            : `/api/organization/${orgCode}/detail`,
          signal: controller.signal,
        })
        if (!active) return
        if (
          !res ||
          !validResponse(res) ||
          res.code !== CODE_SUCCESS ||
          !res.data?.data ||
          res.data.data.success === false
        ) {
          message.error((res && validResponse(res) && res.data?.data?.message) || 'Lấy dữ liệu lỗi')
          Sentry.captureMessage('Lấy dữ liệu lỗi')
          setBannerData({ sourceKey, images: [] })
          return
        }

        const response = res.data.data
        const paths: string[] = Array.isArray(response.bannerPath)
          ? response.bannerPath.filter((item) => typeof item === 'string' && item.trim())
          : []
        setBannerData({
          sourceKey,
          images: paths.map((item) =>
            schoolCode
              ? `${API_URL}res/organization/${orgCode}/school/${schoolCode}/upload/preview/${item}`
              : `${API_URL}res/organization/dhqt/school/dhqt/upload/preview/${item}`,
          ),
          organization: schoolCode ? undefined : response,
        })
      } catch (error) {
        if (!active) return
        message.error('Có lỗi xảy ra')
        Sentry.captureException(error)
        setBannerData({ sourceKey, images: [] })
      }
    }

    getBanner()
    return () => {
      active = false
      controller.abort()
    }
  }, [Get, orgCode, schoolCode, sourceKey, showBanner])
  const handleOnClick = () => {
    const location = window.location.pathname.split('/')

    if (
      (detectEnvUat() &&
        location.slice(0, 6).join('/') ===
          `/uat/organization/${appState.studenInfor?.orgCode}/school/${appState.studenInfor?.schoolCode}`) ||
      location.slice(0, 7).join('/') ===
        `/uat/confirm-payment/organization/${appState.studenInfor?.orgCode}/school/${appState.studenInfor?.schoolCode}`
    ) {
      window.location.replace(`${appState.edubillDetail.schoolUrl + '/#/thanhtoanonline'}`)
    } else if (
      location.slice(0, 5).join('/') ===
        `/organization/${appState.studenInfor?.orgCode}/school/${appState.studenInfor?.schoolCode}` ||
      location.slice(0, 6).join('/') ===
        `/uat/confirm-payment/organization/${appState.studenInfor?.orgCode}/school/${appState.studenInfor?.schoolCode}`
    ) {
      window.location.replace(`${appState.edubillDetail.schoolUrl + '/#/thanhtoanonline'}`)
    } else {
      dispatch(setEduBillDetail(undefined))
      dispatch(setIsHome(true))
      navigate(`${detectEnvUat() ? '/uat' : '/'}`)
    }
  }

  return (
    <>
      <div
        className={`${
          appState.isHome ? 'h-40' : 'h-20'
        } w-full bg-[url('@assets/background/banner.png')] bg-cover bg-no-repeat shadow-lg`}
      >
        <div className="px-2 justify-between  py-3.5 flex">
          <p
            className={`md:text-[22px] font-bold cursor-pointer flex text-[16px] items-center min-w-0 ${
              appState.isHome ? 'justify-center max-w-[350px] md:max-w-[530px]' : 'flex-1'
            }`}
            onClick={() => {
              handleOnClick()
            }}
            style={{
              color: '#045993',
            }}
          >
            {!appState.isHome && (
              <img
                src={edubillDetail?.avatarUrl || dataGroup?.logo}
                alt=""
                className="w-[52px] h-[52px] mr-3 object-contain shrink-0"
              />
            )}
            <span className="min-w-0">
              <span className="block truncate">
                {institutionNameOnOneLine(
                  !appState.isHome ? (!schoolCode ? dataGroup?.orgName : edubillDetail?.schoolName) : 'AQ BILL GATEWAY',
                )}
              </span>

              {showOrgName && (
                <span className="block truncate text-[14px] md:text-[16px] font-normal">
                  {institutionNameOnOneLine(edubillDetail.orgName)}
                </span>
              )}

              {appState.isHome && (
                <span className="font-bold cursor-pointer flex justify-center text-[#045993]">
                  Cổng dịch vụ thu phí trường học EduBill
                </span>
              )}
            </span>
          </p>
          <div className="shrink-0">
            {appState.studenInfor && (
              <div className="hidden md:block ml-4">
                <p className="text-[#595959]">
                  Tên học viên:{' '}
                  <span className="text-[#151515] text-[16px] font-[500]">{appState.studenInfor?.HoTen}</span>
                </p>
                <p className="text-[#595959]">
                  Mã học viên:{' '}
                  <span className="text-[#151515] text-[16px] font-[500]">{appState.studenInfor?.MaSV}</span>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {showBanner && (
        <HeaderBanner
          key={sourceKey || 'default'}
          images={sourceKey ? currentBannerData?.images : emptyImages}
          singleImage={!!searchRoute}
        />
      )}
    </>
  )
}
export default Header
